module.exports = __webpack_public_path__ + "img/5b7827678b41c24d.png";